'use client'

import { useState, type ReactNode } from 'react'
import { FolderTree } from 'lucide-react'
import { LoadingOutline } from '@/components/ui/loading-outline'
import styles from './category-tree-sidebar.module.scss'

export default function NodeImage({
  image,
  loading = false,
  fallback = <FolderTree size={16} />,
}: {
  image?: string | null
  loading?: boolean
  fallback?: ReactNode
}) {
  const [failed, setFailed] = useState(false)

  return (
    <span className={styles.thumbnail} aria-hidden="true">
      {image && !failed ? (
        // eslint-disable-next-line @next/next/no-img-element
        <img src={image} alt="" width={28} height={28} decoding="async" onError={() => setFailed(true)} />
      ) : (
        fallback
      )}
      {loading && <LoadingOutline />}
    </span>
  )
}
